'use client'

import { useState } from 'react'
import Image from 'next/image'
import { cn } from '~shared/utils/cn'
import {  getProgramData } from '~shared/api/single-program-data/single-program-data'


// ─── Constants ────────────────────────────────────────────────────────────────

const TITLE = 'Преподаватели'
const LABEL = 'Преподают ведущие российские и зарубежные эксперты с опытом от 7 до 25 лет'
const BUTTON = 'Посмотреть всех'

// ─── Component ────────────────────────────────────────────────────────────────

export const TeachersSection = ({ program }: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const teachers = program?.teachers

  const [shownCount, setShownCount] = useState(4)

  if (!teachers || teachers.length === 0) return null

  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>

        <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium leading-[120%] mb-[16px] 2lg:mb-[24px]'>
          {TITLE}
        </h2>

        <p className='text-[20px] leading-[140%] max-w-full md:max-w-[488px] 2lg:max-w-[696px] mb-[40px] md:mb-[32px] 2lg:mb-[56px]'>
          {LABEL}
        </p>

        <div className='grid grid-cols-1 md:grid-cols-3 2lg:grid-cols-4 gap-[40px] md:gap-[32px]'>
          {teachers.map((teacher, idx) => (
            <div
              key={`Teachers__teacher--${idx + 1}`}
              className={cn(
                'flex flex-col',
                idx + 1 > shownCount && 'hidden'
              )}>
              {teacher?.image?.url && (
                <div className='relative w-full h-[452px] md:h-auto md:aspect-[3/4] rounded-[16px] overflow-hidden mb-[16px] 2lg:mb-[32px]'>
                  <Image
                    src={teacher.image.url}
                    alt={teacher.image.alternativeText || teacher.name || ''}
                    fill
                    quality={100}
                    className='object-cover'
                  />
                </div>
              )}
              <p className='text-[20px] 2lg:text-[24px] font-medium leading-[120%] mb-[16px]'>
                {teacher.name}
              </p>
              <p
                className='text-[16px] md:text-[14px] 2lg:text-[16px] leading-[140%] text-[#4F4F4F]'
                dangerouslySetInnerHTML={{ __html: teacher.description || '' }}
              />
            </div>
          ))}
        </div>

        {teachers.length > shownCount && (
          <button
            onClick={() => setShownCount(teachers.length)}
            className={cn('mt-[40px] block mx-auto w-full md:w-[40%] py-[16px] px-[32px] rounded-[8px] border text-[16px] font-medium leading-[120%] ',
                'text-[#3a52ee] transition-opacity hover:opacity-70')}
            style={{ borderColor: '#3a52ee' }}>
            {BUTTON}
          </button>
        )}

      </div>
    </section>
  )
}